import { useQuery } from '@tanstack/react-query'
import { ClientBookingSearchService } from '../services/client_booking_search.service'
import { APIBookingSearchByDaysClientDtoResponse, APIBookingSearchClientDtoResponse } from '../types/api'
import { TBookingSearchOptions } from '../types/general'
import { DEFAULT_CACHE_TIME, defaultQueryOptions } from './common'

export const useClientBookingSearch = (
  locationName: string,
  serviceTypeName: string,
  options: TBookingSearchOptions
) => {
  const { cacheEnabled = false, ...queryOptions } = options

  return useQuery<APIBookingSearchClientDtoResponse>({
    queryKey: ['clientBookingSearchRegular', locationName, serviceTypeName, options],
    queryFn: () => ClientBookingSearchService.search(locationName, serviceTypeName, queryOptions),
    // disable the call if the date is invalid
    enabled: options.startDate !== '1969-12-31',
    ...defaultQueryOptions,
    ...(cacheEnabled ? { staleTime: DEFAULT_CACHE_TIME, cacheTime: DEFAULT_CACHE_TIME } : {}),
  })
}

export const useClientBookingSearchByDays = (
  locationName: string,
  serviceTypeName: string,
  options: TBookingSearchOptions
) => {
  return useQuery<APIBookingSearchByDaysClientDtoResponse>({
    queryKey: ['clientBookingSearchByDays', locationName, serviceTypeName, options],
    queryFn: () => ClientBookingSearchService.searchByDays(locationName, serviceTypeName, options),
    // disable the call if the date is invalid
    enabled: options.startDate !== '1969-12-31',
    ...defaultQueryOptions,
  })
}
